var APP = APP || {};

APP.ajaxRequest = null;
APP.pushGaEvent = function (category, action, label) {
    if (typeof (ga) === 'function') {
        ga('send', 'event', category, action, label);
    }
};

$(document).ready(function () {

    $('a[href^="#"]').on('click', function(e) {
        e.preventDefault();
    });

    $(document).on('click', '.show-popup', function (e) {
        e.preventDefault();
        var href = $(this).attr('href');
        var link = href.substring(href.indexOf('#'), href.length);
        APP.openColorbox(link, $(this).hasClass('rules-alternate'));
    });
});

APP.openColorbox = function(link, rulesAlternate){
    if(!rulesAlternate) rulesAlternate = false;
    $.colorbox({ href: link,
        inline: true, overlayClose: link == '#rules', width: '90%', maxWidth: '910', opacity: 0.6, onComplete: function () {
            parent.$.colorbox.resize();
        }, onClosed: function(){
            if((location.origin + location.pathname != APP.baseUrl) && (link != '#rules')) location.href = APP.baseUrl;
        }
    });

    if(link == '#rules' && rulesAlternate) {
        setTimeout(function () {
            location.href = location.origin + location.pathname + '#alternate';
        }, 500);
    }
};

APP.colorboxResize = function(){
	setTimeout(	function(){
			$.colorbox.resize();
		}, 200);    
};